export default __webpack_public_path__ + "static/media/Cloudxier_graphics-each-expertise-02.969e35ea.png";